// extracted by mini-css-extract-plugin
module.exports = {"root":"AutoTheorieLernenPage_root__6afWb","mainImage":"AutoTheorieLernenPage_mainImage__3DWx4","video":"AutoTheorieLernenPage_video__2aax3"};